var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#3C5A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2528 3.07031H11.0376C9.723 3.07031 8.2608 3.62322 8.2608 5.52878C8.26722 6.19276 8.2608 6.82865 8.2608 7.5443H6.73999V9.96437H8.30786V16.9313H11.1889V9.91839H13.0905L13.2625 7.53751H11.1393C11.1393 7.53751 11.144 6.47839 11.1393 6.17082C11.1393 5.41778 11.9228 5.46091 11.97 5.46091C12.3428 5.46091 13.0678 5.46199 13.2539 5.46091V3.07031H13.2528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon02);
export default __webpack_public_path__ + "static/media/login-icon-02.cc9f1b670345d00bdae5b51738f4788a.svg";
export { ForwardRef as ReactComponent };